import React from 'react';
import mapMarker from '../images/iconMarker.png';
import zastava from '../images/mapZastava.png';
import domen from '../images/domen.png';

import {
    Container,
    Row,
    Col,
} from 'reactstrap';

export default class Map extends React.Component {
    constructor(props) {
        super(props);
        this.initMap = this.initMap.bind(this);
        this.state = {};
        }
 
    initMap() {
        this.setState({
            _mapInit: true
        });

 
        var latLng = new window.google.maps.LatLng(44.7695437, 19.2162683);

        var map = new window.google.maps.Map(this.GoogleMap, {
            zoom: 18,
            center: latLng,
            mapTypeId: window.google.maps.MapTypeId.ROADMAP,
            disableDefaultUI: true,
            gestureHandling: "gestureHandling",
        });


        var marker = new window.google.maps.Marker({
            position: latLng,
            map: map,
            icon: mapMarker
        });

    }

     componentDidMount() {
        if (this.props.mapinit && !this.state._mapInit) {
            this.initMap();
        }
  
    }

    componentDidUpdate() {
        if (this.props.mapinit && !this.state._mapInit) {
            this.initMap();
        }
    }

    render() {
        return (
            <div>
                <div className = "googleMap">
                <Container>
                    <Row>
                        <Col xl={12} lg={12} md={12} sm={12}>
                            {
                                this.props.mapinit ?
                                    <div className="map" ref={(input) => { this.GoogleMap = input; }}>
                                        <Container>
                                            <Row>

                                            </Row>
                                        </Container>
                                    </div>
                                    : null
                            }
                        </Col>
                    </Row>
                    <hr className = "yellowLine"></hr>
                    <hr className = "redLine"></hr>
                    <img src={zastava} className = "img-fluid mapZastava"></img>
                </Container>
                </div>
                <Container className = "blackLine">
                    <img src={domen}></img>
                </Container>
            </div>
        );
    }
}
